<template>
  <div class="user-logged-form__item">
    <label class="typo__label">{{ $t('organization_name') }}*</label>
    <input type="text" class="control" disabled :value="firmTitle">
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'FirmInput',
  props: {
    firmTitle: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      formData: state => state.checkout.formData
    })
  },
  methods: mapActions(['SET_FORM_DATA'])
}
</script>
